import { render, staticRenderFns } from "./SalaryRules.vue?vue&type=template&id=5bb2b84c&"
import script from "./SalaryRules.vue?vue&type=script&lang=js&"
export * from "./SalaryRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports